module.exports = __webpack_public_path__ + "static/logo-7913b015153216c44dafce61f27062a5.png";